// extracted by mini-css-extract-plugin
module.exports = {"step7":"TPStep7_step7__1JG5m","submissionBody":"TPStep7_submissionBody__bOItn"};